import { getWindow } from '../get-window'

/**
 * Saves a Blob to the user's disk under the given filename, through a temporary anchor click, and revokes
 * the object URL it created. Browser only: it needs `document`, so call it from a click handler.
 *
 * @param blob - The file content
 * @param filename - The name the browser saves the file as, extension included
 *
 * @example
 * downloadBlob(new Blob(['a,b'], { type: 'text/csv' }), 'report.csv')
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const win = getWindow()
  const url = URL.createObjectURL(blob)
  const anchor = win.document.createElement('a')
  anchor.href = url
  anchor.download = filename
  win.document.body.appendChild(anchor)
  anchor.click()
  win.document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
